import { useQuery } from '@tanstack/react-query';
import { getArchive, getDocumentation } from '../../api/workEnvironmentQueries';

export const ArchiveQueryKey = 'WORK_ENVIRONMENT_ARCHIVE';
export const DocumentationQueryKey = 'WORK_ENVIRONMENT_DOCUMENTATION';

export const useArchiveQuery = (surveyId: number, language: string) =>
  useQuery({
    queryKey: [ArchiveQueryKey, surveyId, language],
    queryFn: () => getArchive(surveyId, language),
  });

export const useDocumentationQuery = (surveyId: number, language: string) =>
  useQuery({
    queryKey: [DocumentationQueryKey, surveyId, language],
    queryFn: () => getDocumentation(surveyId, language),
  });
